import * as request from "../lib/lib";

const baseUrl = process.env.REACT_APP_BACKEND_URL + 'Ranking';

export const checkIsOpenForAccepting = async () => {
    const result = await request.get(`${baseUrl}/OpenForAccepting`);

    return result;
};

export const checkIsOpenForRegister = async () => {
    const result = await request.get(`${baseUrl}/OpenForRegister`);

    return result;
};

export const confirmApplication = async (id, schoolId) => {
    const result = await request.put(`${baseUrl}/ConfirmApplication/${id}${schoolId ? `?schoolId=${schoolId}` : ''}`);

    return result;
}

export const denyApplication = async (id, schoolId) => {
    const result = await request.put(`${baseUrl}/DenyApplication/${id}${schoolId ? `?schoolId=${schoolId}` : ''}`);

    return result;
}

export const denyCancellationApplication = async (id, schoolId) => {
    debugger
    const result = await request.put(`${baseUrl}/DenyCancelledApplication/${id}${schoolId ? `?schoolId=${schoolId}` : ''}`);

    return result;
}

export const CancelApplicationAfterExpRank = async (id, schoolId) => {
    debugger
    const result = await request.put(`${baseUrl}/CancelApplicationFromExpiredRanking/${id}${schoolId ? `?schoolId=${schoolId}` : ''}`);

    return result;
}